import { FC } from 'react';

import styles from './styles.module.scss';

export const SkeletonSchedule: FC = () => {
  const rows = new Array(5).fill(7);

  return (
    <div className={styles['skeleton-schedule']}>
      {rows.map((cardsCount, columnIndex) => (
        <div
          key={columnIndex}
          className={styles['skeleton-schedule__container']}
        >
          {Array(cardsCount)
            .fill(null)
            .map((_, cardIndex) => (
              <div
                key={cardIndex}
                className={styles['skeleton-schedule__card']}
              />
            ))}
        </div>
      ))}
    </div>
  );
};
